import * as React from 'react';
import { useState, useMemo } from 'react';
import {
  Box,
  Container,
  FormControl,
  InputLabel,
  NativeSelect,
  Paper,
  Typography,
} from '@mui/material';
import Log from '../../lib/log';
import { v2api } from '../../api/axios';
import { formatNumber } from '../../functions/Utils';

// ログの初期化
const log = new Log('SetupTransfer');

// 転送設定タイプ
export interface TransferGuideType {
  id: number;
  carrier: string;
  guide: string;
  title: string;
}
// イベントタイプ
type onChangeEvent = React.ChangeEvent<HTMLSelectElement>;

// プロパティタイプ
interface Props {
  id: string;
  token: string;
  serviceNumber: string;
}
export default function SetupTransfer(props: Props) {
  log.putLog('info', 'SetupTransfer started.');
  const { id, token, serviceNumber } = props;

  // 転送設定ガイド
  const [transferGuides, setTransferGuides] = useState<TransferGuideType[]>();

  useMemo(() => {
    (async () => {
      try {
        // kintoneからお知らせを取得する
        const postData = {
          userId: id,
          token,
        };
        const res = await v2api.post('/get-transfer-guide', postData);
        if (res.data.statusCode === 200) {
          // 取得成功
          const records = JSON.parse(res.data.body).records;
          const transferGuides: TransferGuideType[] = records.map(
            (record: any) => {
              const transferGuide = {
                id: Number(record['レコード番号'].value),
                carrier: record.carrier.value,
                guide:
                  record.guide.value.replace(
                    /ServiceNumber/g,
                    `${serviceNumber}`,
                  ) || '',
                title: record.title.value,
              };
              return transferGuide;
            },
          );
          transferGuides.sort((a, b) => a.id - b.id); // レコード番号順にソート
          setTransferGuides(transferGuides);
          console.dir(transferGuides);
        }
      } catch (err: any) {
        log.putLog('error', err.message ? err.message : err);
      }
    })();
  }, [id, token, serviceNumber]);

  // リスト選択
  const [guide, setGuide] = useState('');
  const handleChangeCarrier = (e: onChangeEvent) => {
    console.log(`🐞 list changed. ${e.target.value}`);
    const guides = transferGuides?.filter(
      (transferGuide) => transferGuide.carrier === e.target.value,
    );
    if (guides && guides.length > 0) {
      setGuide(guides[0].guide);
    } else {
      setGuide('');
    }
  };

  return (
    <div>
      <Container component='main' maxWidth='xs'>
        <Box sx={{ minWidth: 120, mt: 5 }}>
          <FormControl fullWidth>
            <InputLabel variant='standard' htmlFor='uncontrolled-native'>
              ご利用中の電話会社を選択してください。
            </InputLabel>
            <NativeSelect
              defaultValue={'--'}
              inputProps={{
                name: 'carrier',
                id: 'uncontrolled-native',
              }}
              onChange={handleChangeCarrier}
            >
              <option value={'--'}>リストから選択してください</option>
              {transferGuides?.map((transferGuide) => (
                <option
                  value={transferGuide.carrier}
                  key={transferGuide.carrier}
                >
                  {transferGuide.title}
                </option>
              ))}
            </NativeSelect>
          </FormControl>
        </Box>
      </Container>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: 'auto',
        }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: guide,
          }}
        />
      </Paper>
      <Typography component='p' color={'red'} sx={{ mt: 5 }}>
        転送先番号には、必ず{formatNumber(serviceNumber)}
        を設定してください。間違った番号を設定すると、その方に電話が転送されてしまうので気をつけてください。
      </Typography>
    </div>
  );
}
